import { RunAutoCombineDriverTripsInput, RunAutoCombineDriverTripsResponse } from '@/models/gen/graphql';

import { GraphApiResponse } from '@/api/core';
import { RunAutoCombineDriverTripsDocument } from '@/api/queries';
import { Validation } from '@/utils/validations';
import graphApi from '@/api';
import { handleError } from '@/utils/custom';

type RunAutoCombineDriverTripsGraphApiResponse = GraphApiResponse<typeof RunAutoCombineDriverTripsDocument>;

const runAutoCombineDriverTripsValidator = new Validation.Validator({
  'driverId!': (val: string): Validation.Validity => ({
    valid: !!val && Validation.isValidUUID(val),
  }),
  'tripId!': (val: string): Validation.Validity => ({
    valid: !!val && Validation.isValidUUID(val),
  }),
  'scheduled!': (val: string): Validation.Validity => ({
    valid: !!val && Validation.isDate(val) ? true : val?.length ? false : undefined,
  }),
  'providerId!': (val: string): Validation.Validity => ({
    valid: !!val && Validation.isValidUUID(val),
  }),
  'puLocationId!': (val: string): Validation.Validity => ({
    valid: !!val && Validation.isValidUUID(val),
  }),
  'doLocationId!': (val: string): Validation.Validity => ({
    valid: !!val && Validation.isValidUUID(val),
  }),
  vehicleId: (val: string): Validation.Validity => ({
    valid: !!val && Validation.isValidUUID(val) ? true : val?.length ? false : undefined,
  }),
  vehicleCapacity: (val: number): Validation.Validity => ({
    valid: !!val && Validation.isNumber(val) ? true : val ? false : undefined,
  }),
  airportCode: (val: string): Validation.Validity => ({ valid: !!val }),
});

const runAutoCombineDriverTripsResponseSelector = (res: RunAutoCombineDriverTripsGraphApiResponse): RunAutoCombineDriverTripsResponse =>
  !res.errors ? ((res?.runAutoCombineDriverTrips || {}) as RunAutoCombineDriverTripsResponse) : undefined;

const [runRunAutoCombineDriverTrips] = graphApi(RunAutoCombineDriverTripsDocument, {
  onError: (res: RunAutoCombineDriverTripsGraphApiResponse): void =>
    handleError(res, { notification: { title: 'Auto Combine Driver Trips' } }),
});

const runAutoCombineDriverTrips = async (input: RunAutoCombineDriverTripsInput): Promise<RunAutoCombineDriverTripsResponse> => {
  input = runAutoCombineDriverTripsValidator.create(input);
  const res = await runRunAutoCombineDriverTrips({ input });
  return runAutoCombineDriverTripsResponseSelector(res);
};

export default runAutoCombineDriverTrips;
